import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class NameKana extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): NameKana {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new NameKana(value);
  }

  /** ラベル */
  static get label(): string {
    return '名前 (ひらがな)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'たろう';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      pattern: {
        /** 値 */
        value: /^([ぁ-ん]){1,128}$/,
        /** メッセージ */
        message: '1文字以上かつ128文字以下かつ「ひらがな」である必要があります',
      },
    };
  }

  /** キー */
  static get key() {
    return 'nameKana';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
